import Model from "./abstract/Model";
import Address from "./Address";
import Attachment from "./Attachment";
import Client from "./Client";
import ConkedOutVehicle from "./ConkedOutVehicle";
import ContractStatus from "./ContractStatus";
import Person from "./Person";
import Vehicle from "./Vehicle";
import CostDetermination from "./CostDetermination";
import ContractExtension from "./ContractExtension";

export const LocationType = {
  CUSTOMER: "CUSTOMER",
  DEPOT: "DEPOT",
  OTHER: "OTHER",
  UNKNOWN: "UNKNOWN"
};

export const CreditType = {
  FULL: "FULL",
  LIMITED: "LIMITED"
};

export default class Contract extends Model {
  country_ids;
  contract_cost_determinations_dict; // {[cost_determination_id]: CostDeterminationSelection}
  constructor(props) {
    super();

    this.initializeAttributes(props, this.getMap());
  }

  getMap() {
    return {
      vehicle: Vehicle,
      customer: Person,
      client: Client,
      conked_out_vehicle: ConkedOutVehicle,
      person: Person,
      address_drop_off: Address,
      address_return: Address,
      status: ContractStatus,
      start_datetime: Date,
      first_extension: ContractExtension,
      extensions: value => ContractExtension.list(value),
      end_datetime: Date,
      signed_off_at: Date,
      attachments: value => Attachment.list(value),
      public_attachments: value => Attachment.list(value),
      contract_cost_determinations: value => {
        const dict = {};
        value.map(item => {
          dict[item.cost_determination_id] = {
            selection: item.selection
          };
        });
        this.contract_cost_determinations_dict = dict;

        return value;
      },
      cost_determinations: value => CostDetermination.list(value)
    };
  }

  get duration_in_days() {
    if (this.start_datetime && this.end_datetime) {
      const diffTime = this.end_datetime - this.start_datetime.getTime();
      let diffInDays = diffTime / (1000 * 60 * 60 * 24);

      // if (this.round) {
      //   const roundDownUntilHours = this.round_up_after;

      //   diffInDays = Math.floor(
      //     diffInDays % 1 < roundDownUntilHours / 24
      //       ? diffInDays
      //       : parseInt(diffInDays) + 1
      //   );
      // }

      // diffInDays = diffInDays.toFixed(1);
      // if (diffInDays.endsWith(".0")) diffInDays = parseInt(diffInDays);

      return Math.round(diffInDays);
    }
  }
}
